// Components
import SWRConfigWrapper from '@/components/layouts/SWRConfigWrapper';
import { HeaderPlatform } from '@/components/layouts/LayoutPlatform/components/Header';
import { GlobalWrapper } from '@/components/layouts/LayoutPlatform/GlobalWrapper';

type LayoutPlatformProps = { children: React.ReactNode };
function LayoutPlatform({ children }: LayoutPlatformProps) {
    return (
        <SWRConfigWrapper>
            <div className="flex h-screen w-screen overflow-hidden bg-white bg-icoLoggedInLayer dark:bg-icoDarkMode-deepBlack dark:bg-icoLoggedInLayerDark">
                <GlobalWrapper>{children}</GlobalWrapper>
            </div>
        </SWRConfigWrapper>
    );
}

export { LayoutPlatform, HeaderPlatform };
